import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const StatsChart = ({ gamesPlayed, wins, losses }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'TEAM PERFORMANCE OVERVIEW',
        color: '#fff',
        font: {
          size: 16,
          family: "'Outfit', sans-serif"
        }
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: '#a5d8ff',
          font: {
            family: "'Outfit', sans-serif"
          }
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      },
      x: {
        ticks: {
          color: '#a5d8ff',
          font: {
            family: "'Outfit', sans-serif"
          }
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      }
    },
  };

  const data = {
    labels: ['Games Played', 'Wins', 'Losses'],
    datasets: [
      {
        label: 'Count',
        data: [gamesPlayed, wins, losses],
        backgroundColor: [
          'rgba(74, 144, 226, 0.7)',
          'rgba(46, 204, 113, 0.7)',
          'rgba(231, 76, 60, 0.7)',
        ],
        borderColor: [
          'rgba(74, 144, 226, 1)',
          'rgba(46, 204, 113, 1)',
          'rgba(231, 76, 60, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="statsChart">
      <Bar options={options} data={data} />
    </div>
  );
};

export default StatsChart;